import { useContext } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import { FaArrowCircleRight, FaDownload } from "react-icons/fa";

export default function OneNews({ data, showDescription = true }) {
  const appContext = useContext(AppContext);

  function view() {
    appContext.navTo({
      item: "view",
      subItem: "news",
      extraItem: data.uuid,
    });
  }

  const photoUrl = data?.coverPhoto ? `${CDN_URL}${data.coverPhoto}` : "";
  const parsedDate = getParsedDate(data?.dateCreated);
  const monthShort = parsedDate
    ? parsedDate.toLocaleString("en-US", { month: "short" }).toUpperCase()
    : "N/A";
  const dayNumber = parsedDate ? String(parsedDate.getDate()).padStart(2, "0") : "--";
  const fullDate = parsedDate
    ? parsedDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
    : "Unknown date";
  const fullTime = parsedDate
    ? parsedDate.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })
    : "--:--";
  const isRecent = parsedDate
    ? Date.now() - parsedDate.getTime() <= 7 * 24 * 60 * 60 * 1000
    : false;

  function getParsedDate(value) {
    if (value === undefined || value === null || value === "") return null;
    const asNumber = Number(value);
    if (!Number.isNaN(asNumber) && Number.isFinite(asNumber)) {
      const normalized = asNumber < 1000000000000 ? asNumber * 1000 : asNumber;
      const dateFromNumber = new Date(normalized);
      if (!Number.isNaN(dateFromNumber.getTime())) return dateFromNumber;
    }
    const dateFromString = new Date(value);
    return Number.isNaN(dateFromString.getTime()) ? null : dateFromString;
  }

  return (
    <div
      style={{
        cursor: "pointer",
        borderRadius: "14px",
        overflow: "hidden",
        marginBottom: "18px",
        background: "#ffffff",
        position: "relative",
        boxShadow: "0 8px 22px rgba(0,0,0,0.08)",
        transition: "transform 160ms ease, box-shadow 160ms ease",
        border: "1px solid rgba(0,0,0,0.08)",
      }}
      onClick={view}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 14px 34px rgba(0,0,0,0.12)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 8px 22px rgba(0,0,0,0.08)";
      }}
    >
      <div
        style={{
          padding: "14px 14px 10px 14px",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "12px",
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: "12px", minWidth: 0, flex: 1 }}>
          <div
            style={{
              minWidth: "62px",
              width: "62px",
              height: "62px",
              borderRadius: "10px",
              background: "linear-gradient(145deg, #f4f8f2, #e7efe3)",
              border: "1px solid rgba(34, 139, 34, 0.25)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: 1.05,
            }}
          >
            <div
              style={{ fontSize: "11px", color: "#2f6e3a", letterSpacing: "0.4px" }}
              className="font-semi-bold"
            >
              {monthShort}
            </div>
            <div style={{ fontSize: "23px", color: "#17381d" }} className="font-bold">
              {dayNumber}
            </div>
          </div>

          <div style={{ minWidth: 0, flex: 1 }}>
            <div
              style={{
                fontSize: "13px",
                color: "#57695b",
                letterSpacing: "0.3px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "wrap",
              }}
              className="font-semi-bold"
            >
              <span>
                {fullDate} @ {fullTime}
              </span>
            </div>

            <div className="d-flex align-items-start gap-2" style={{ marginTop: "4px", minWidth: 0 }}>
             
              <h6
                style={{
                  margin: 0,
                  fontSize: "19px",
                  color: "#18291c",
                  lineHeight: "1.35",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                className="font-bold"
              >
                {data?.title || "Untitled"}
              </h6>
            </div>
          </div>
        </div>

        <div
          style={{
            width: "120px",
            height: "84px",
            borderRadius: "10px",
            flexShrink: 0,
            backgroundColor: "#e9efea",
            border: "1px solid rgba(0,0,0,0.08)",
            backgroundImage: photoUrl ? `url(${photoUrl})` : "none",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
          className="mDesktopOnly"
        />
      </div>

      <div
        style={{
          padding: "0 14px 14px 14px",
        }}
      >
        {showDescription && (
          <p
            style={{
              margin: 0,
              fontSize: "15px",
              color: "#4b5c4f",
              lineHeight: "1.6",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            className="font-semi-bold"
          >
            {data?.description || ""}
          </p>
        )}

        <div
          style={{
            marginTop: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <div
            style={{
              fontSize: "14px",
              color: "#5a6c5f",
            }}
            className="font-semi-bold"
          >
            Tap to read details
          </div>

          <div
            style={{
              padding: "10px 12px",
              borderRadius: "12px",
              background: "rgba(34, 139, 34, 0.10)",
              border: "1px solid rgba(34, 139, 34, 0.24)",
              color: "#204f2b",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
            className="font-semi-bold mDesktopOnly"
          >
            <FaArrowCircleRight style={{ fontSize: "14px", color: "#204f2b" }} />
            <span style={{ fontSize: "14px" }}>Open News</span>
          </div>
        </div>
      </div>
    </div>
  );
}
